import styled from "styled-components";

export const SelectStyled = styled.div`
    .Polaris-Labelled__LabelWrapper {
        margin-right: 10px;
    }

    .Polaris-Labelled__Action {
        font-size: 12px;
    }
`